import '@sass/blocks/search/_searcharea.scss'

import {triggerCallbackAfterEventOrIfFired, triggerDocumentEvent} from "@js/globalFunctions/events";

require('@js/third-party/animateNumber');

//General
import { resetAllSearchParts } from '@js/parts/search/functions/reset/resetAllSearchParts'
import { applyPregenSearchParameters } from '@js/parts/search/functions/logic/applyPregenSearchParams'
import { addSelectedSearch } from '@js/parts/search/functions/logic/addSelectedSearch'
import { startLargeLoader, endLargeLoader } from '@js/globalFunctions/loaders'
import {updateCriteriaScrollBarVisible,updateExtraSpacerHeight} from "@js/parts/search/functions/frontadvancedSearchViewStates";

//Areas
import { updateSelectedAreas } from '@js/parts/search/functions/areaSelector/updateSelectedAreas'
import { resetAreaSelector } from '@js/parts/search/functions/areaSelector/resetAreaSelector'
import { addRemoveSlugFromAreaHolder } from '@js/parts/search/functions/areaSelector/addRemoveSlugFromAreaHolder'

//Changedate
import { updateSelectedChangedays } from '@js/parts/search/functions/changeDays/updateSelectedChangedays'
import {updateViableDatePickerDays} from "@js/parts/search/functions/searchfilterbox/updateViableDatePickerDays";
import {updateDateRangeValue} from "@js/parts/search/functions/searchfilterbox/updateDateRangeValue";
import getDateWeekNr from "@js/globalFunctions/getDateWeekNr";
import {updateTagsView} from "@js/parts/search/functions/searchfilterbox/updateTagsView";
import {toggleSearchCalendarVisibility} from "@js/parts/search/functions/searchfilterbox/toggleSearchCalendarVisibility";

$(document).ready(function() {
	/***********************************************************************
		  .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-
		 / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \
		`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'
								VISIBLE

	 ************************************************************************/

	updateCriteriaScrollBarVisible();
	updateExtraSpacerHeight();
	$(window).on('resize', function(){
		updateCriteriaScrollBarVisible();
		updateExtraSpacerHeight();
	});

	$(document).on('click','#cn-accept-cookie',function(){
		setTimeout(() => {
			updateExtraSpacerHeight();
		},500);
	});



	/***********************************************************************
		  .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-
		 / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \
		`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'
								INIT

	************************************************************************/

	applyPregenSearchParameters();

	generateOffDateArrivalOptions();
	const arrival = searchParameters.getParameter('ankomst');
	if(arrival !== undefined)
	{
		$('.useSpecificArrivalWrap').removeClass('hidden')
	}

	if (window.location.href.indexOf("filter=1&") === -1) {
		addSelectedSearch();
		triggerDocumentEvent('pageIsReadyForSearch');
	}else{
		triggerCallbackAfterEventOrIfFired('hasHandledFilters',() => triggerDocumentEvent('pageIsReadyForSearch'));
	}







	/***********************************************************************
		  .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-
		 / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \
		`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'
	                            GENERAL INPUTS

	************************************************************************/

	$(document).on('searchChanged',function(){
		generateOffDateArrivalOptions();
		$('.search-calendar-wrapper').addClass('hidden');
		if(dataholder.isSearchCalendarActive)
		{
			const arrival = searchParameters.getParameter('specificAnkomst');
			if(arrival !== undefined)
			{
				$('#dateSelect').val(arrival);
				updateTagsView();
				$('.useSpecificArrivalWrap').removeClass('hidden')
			}
			else
			{
				$('.useSpecificArrivalWrap').addClass('hidden')
			}

			const useSpecific = searchParameters.getParameter('useSpecificArrival');
			$('input[name=useSpecificArrival]')[0].checked = (useSpecific !== 'True')
		}
	});

	if(dataholder.isSearchCalendarActive) {
		$(document).on('mousedown', '#dateSelect', function (e) {
			if (e.which === 1) {
				e.preventDefault();
				this.blur();
				window.focus();

				toggleSearchCalendarVisibility();
			}
		})

		$(document).on('click','.search-calendar-open',function(e){
			if($(e.target).closest('#dateSelect').length === 0 && $(e.target).closest('.search-calendar-wrapper').length === 0 && $(e.target).closest('.useSpecificArrivalWrap').length === 0)
			{
				$('body').removeClass('search-calendar-open');
				$('.search-calendar-wrapper').addClass('hidden');
				if($('#areaSelectorBox').hasClass('hidden'))
					$('#esmark-map').removeClass('hidden');
			}
		})
	}

	if( $(document).find("#searcharea").hasClass("sticky") === true ){
		$(document).find("#searcharea").parent(".left").addClass("sticky");
	}

	$(document).on('click','#r_arrow', function(e){
		if( !$('#esmark-map').hasClass('hidden') ){
			$('#esmark-map').addClass('hidden');
			$('#r_arrow').addClass('isBeingDisplayed');
			$('#calendarHolder').addClass('advancedIsActive');
		}

		$(this).hide().siblings("#u_arrow").show();
		$('#searcharea').addClass('expandedVisible');
		updateCriteriaScrollBarVisible();
	});

	$(document).on('click','#u_arrow', function(e){
		$('#esmark-map').removeClass('hidden');
		$('#r_arrow').removeClass('isBeingDisplayed');
		$('#calendarHolder').removeClass('advancedIsActive');
		if( !$('.map-gradient').hasClass('hidden') ){
			$('.map-gradient').addClass('hidden');
		}
		$('#searcharea').scrollTop(0);

		$(this).hide().siblings("#r_arrow").show();
		$('#searcharea').removeClass('expandedVisible');
		updateCriteriaScrollBarVisible();
	});


	$(document).on('click', "input.searchValue", function(e){
		if($(e.currentTarget).attr('type') === 'checkbox') {

			let isChecked = e.currentTarget.checked;
			const name = e.currentTarget.getAttribute('name');
			const isReversed = e.currentTarget.classList.contains('reversed');
			if (isChecked)
				isChecked = 'True';

			if(isReversed)
				isChecked = isChecked === false ? 'True' : false;

			searchParameters.setParameter(name, isChecked)
			triggerDocumentEvent('searchChanged');
		}
	});

	$(document).on('change', "select.searchValue", function (e) {
		let val = e.currentTarget.value;
		let name = e.currentTarget.getAttribute('name');
		if(val === 'lastminute') {
			e.preventDefault()
			window.location.href = "/last-minute/"
		}else{
			if(name === 'ankomst' && val === 'miniferie')
			{
				$('#search-mode-toggle').trigger('click');
			}
			else
			{
				searchParameters.setParameter(name, val)
				triggerDocumentEvent('searchChanged');
			}
		}
	});

	$(document).on('change', "select.searchValue", function (e) {
		let val = $(e.currentTarget).val();
		let hasClass = $(e.currentTarget).hasClass('highlight');
		if (val === 'none' && hasClass === true) {
			$(e.currentTarget).removeClass('highlight');
		}
		else if (val !== 'none' && hasClass === false) {
			$(e.currentTarget).addClass('highlight');
		}
	});

	$(document).on('click', '.roadSelectionSmall', function(e){
		var roadId = $(e.currentTarget).data('road');
		var selectedRoad = $(document).find("#vejnavn .tid" + roadId + "").val();
		$(document).find('#vejnavn').val(selectedRoad).change();
	});

	let scrollToThisElement;
	// MAIN SEARCH
	$(document).on('click', ".searchButton", function(e){

		e.preventDefault();
		var curUrl = window.location.href;
		if(curUrl.indexOf(siteSearchPage + "?result") === -1 ){
			startLargeLoader();
			var url = $('.fullSearchSubmitBtnClass').data('url');
			$.ajax({
				url: url,
				type: 'GET',
				success:function(data){
					endLargeLoader();
					if(searchParameters.hasParameters()) {
						const obj = searchParameters.getParameters();
						if(Object.keys(obj).length === 1 && typeof obj.omraader !== 'undefined' && data === '0' && typeof obj.omraader !== 'undefined' && obj.omraader.split(',').length === 1 && obj.omraader !== '')
						{
							const el = $('.areaDotSelect.'+obj.omraader);
							const url = el.length !== 0 ? el.attr('data-url') : undefined;
							if(url !== undefined)
							{
								window.location.href = url;
								return;
							}
						}
					}


					window.location.href = siteSearchPage + "?result/#/page=/1";
				}
			});
		}else{
			resetAreaSelector();
			$('body').removeClass("searchAreaShown");
			$("#searcharea").removeClass("showit");
			$("#search-kat-number").removeClass("showit");
			scrollToThisElement = $(document).find(".search-wrap");
			$('html,body').animate({
				scrollTop: (scrollToThisElement.offset().top) - 3
			}, 300);
		}
	});

	updateSearchButtonPosition();
	$(window).on('scroll',function(e)
	{
		updateSearchButtonPosition();
	});

	function updateSearchButtonPosition(){
		const searchBounds = $('#searcharea')[0].getBoundingClientRect();
		let point = searchBounds.y;
		point += $('.fullSearchSubmitWrapper').outerHeight();
		if(point > 0)
		{
			$('.fullSearchSubmitWrapper').removeClass('stopBottom');
		}
		else if(window.location.href !== siteUrl+'/')
		{
			$('.fullSearchSubmitWrapper').addClass('stopBottom');
		}
		updateExtraSpacerHeight();
	}







	/***********************************************************************
		  .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-
		 / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \
		`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'
								MINIFERIE

	 ************************************************************************/
	$(document).on('click','.datepicker__month-button',function(e){
		updateViableDatePickerDays();
		let lastSelected = $('.datepicker__month-day--selected').length;
		let i = 0;
		const interval = setInterval(() => {
			const currentSelected = $('.datepicker__month-day--selected').length;
			if(lastSelected === currentSelected)
				updateViableDatePickerDays();

			i++;
			if(i > 10)
				clearInterval(interval)
		},50)
	});




	/***********************************************************************
		  .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-
		 / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \
		`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'
								FREE TEXT

	************************************************************************/

	var inputSearchCommandCount = 0;
	$(document).on('input', "input.searchValue", function(e){
		if($(e.currentTarget).attr('type') === 'text' && !dataholder.freeTextProgrammaticChange) {
			dataholder.freeTextProgrammaticChange = true;
			inputSearchCommandCount++;
			var localCounter = inputSearchCommandCount;
			setTimeout(function(){
				if(localCounter === inputSearchCommandCount)
				{
					var val = e.currentTarget.value;

					$('#freeSearchInputField').val(val);
					if(val === '')
					{
						searchParameters.removeParameter('textQuery')
					}
					else
					{
						searchParameters.setParameter('textQuery', val)
					}

					triggerDocumentEvent('searchChanged');
				}
			},300);
			dataholder.freeTextProgrammaticChange = false;
		}
	});







	/***********************************************************************
		  .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-
		 / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \
		`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'
								AREA SELECTOR

	************************************************************************/

	$(document).on('mousedown','#areaSelector', function(e){
		if( e.which === 1 )
		{
			e.preventDefault();
			this.blur();
			window.focus();
			if($('#areaSelectorBox').hasClass('hidden'))
			{

				if( !$('#changeDateSelectorBox').hasClass('hidden') )
					$('#changeDateSelectorBox').addClass('hidden');

				if( !$('#r_arrow').hasClass('isBeingDisplayed') )
					$('#esmark-map').addClass('hidden');

				$('#areaSelectorBox').removeClass('hidden');

				if( /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && $(window).width() < 767) {
					if( !$('body').hasClass('searchAreaShown') ){
						var header = $('#header');
						var offsetTop = header.position().top + header.outerHeight(true);
						$('html,body').animate({scrollTop: offsetTop},300);
					}
				}
			}
			else
			{
				resetAreaSelector();
			}
			if( typeof hj !== 'undefined' && typeof hj === 'function' )
			{
				hj('trigger', 'omraadevaelgeraktiv');
			}
			updateCriteriaScrollBarVisible();
		}
	});

	$(document).on("click", ".vactionAreaSelector,.dkHighlightedAreas", function(e){
		if( e.which === 1 )
		{
			e.preventDefault();
			this.blur();
			window.focus();
			if($('#AreaMapSelectorApp').length !== 0)
			{
				$('#areaSelector').trigger('click')
			}
			else
			{
				if($('#areaSelectorBox').hasClass('hidden'))
				{
					if( !$('#r_arrow').hasClass('isBeingDisplayed') )
					{
						$('#esmark-map').addClass('hidden');
					}
					$('#areaSelectorBox').removeClass('hidden');
				}
				else
				{
					resetAreaSelector();
				}
			}
		}
	});

	$(document).on('click','.map-close-btn, .map-save-btn', function(e){
		if( e.which === 1 )
		{
			if(!$('#areaSelectorBox').hasClass('hidden'))
			{
				resetAreaSelector();
			}
		}
	});

	$(document).on('click', '.selectAllAreaInputs', function(e){

		var current = $(e.currentTarget).is(':checked');
		var els = $('.areaDotSelect');
		dataholder.selectedAreaHolder = Array();

		if( current === true )
		{
			for(var i = 0; i < els.length; i++)
			{
				dataholder.selectedAreaHolder.push( $(els[i]).attr('data-slug') );
			}
		}
		updateSelectedAreas( dataholder.selectedAreaHolder );
		triggerDocumentEvent('searchChanged');
	});

	$(document).on('click','.areaSelectInput:not(.selectAllAreaInputs), .areaDotSelect', function(e){
		dataholder.selectedAreaHolder = addRemoveSlugFromAreaHolder( $(e.currentTarget).attr('data-slug'), dataholder.selectedAreaHolder );
		updateSelectedAreas( dataholder.selectedAreaHolder );
		triggerDocumentEvent('searchChanged');
	});









	/***********************************************************************
		  .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-
		 / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \
		`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'
								CHANGEDATE SELECTOR

	************************************************************************/

	$(document).on('mousedown','select[name=skiftedag]', function(e){
		if( e.which === 1 )
		{
			e.preventDefault();
			this.blur();
			window.focus();
			if( $('#changeDateSelectorBox').hasClass('hidden') )
			{
				if($('#AreaMapSelectorApp').length === 0 && !$('#areaSelectorBox').hasClass('hidden') ){
					$('#areaSelector').trigger('click');
				}
				$('#changeDateSelectorBox').removeClass('hidden');
			}
			else
			{
				$('#changeDateSelectorBox').addClass('hidden');
			}
		}
	});

	$(document).on('click','.skiftedag-close-btn, .skiftedag-save-btn', function(e){
		if( e.which === 1 )
		{
			if(!$('#changeDateSelectorBox').hasClass('hidden'))
			{
				$('#changeDateSelectorBox').addClass('hidden');
			}
		}
	});

	$(document).on('click', '.selectAllChangeDateInputs', function(e){
		var current = $(e.currentTarget).is(':checked');
		var els = $('.changeDateSelectInput:not(.selectAllChangeDateInputs)');
		dataholder.selectedChangedayHolder = Array();

		if( current === true )
		{
			for(var i = 0; i < els.length; i++)
			{
				dataholder.selectedChangedayHolder.push( $(els[i]).attr('data-key') );
			}
		}
		updateSelectedChangedays( dataholder.selectedChangedayHolder );
		triggerDocumentEvent('searchChanged');
	});

	$(document).on('click','.changeDateSelectInput:not(.selectAllChangeDateInputs)', function(e){
		var els = $('.changeDateSelectInput:not(.selectAllChangeDateInputs)');
		dataholder.selectedChangedayHolder = Array();

		for(var i = 0; i < els.length; i++)
		{
			var key = $(els[i]).attr('data-key');
			if( $(els[i]).is(':checked') )
			{
				dataholder.selectedChangedayHolder.push(key);
			}
		}

		updateSelectedChangedays( dataholder.selectedChangedayHolder );
		triggerDocumentEvent('searchChanged');
	});








	/***********************************************************************
		  .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-
		 / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \
		`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'
								SEARCH FILTERS

	************************************************************************/

	$(document).on('click','.searchFilterTag',function(e){
		var filter = $(e.currentTarget).attr('data-filter');
		if($('select.searchValue[name="'+filter+'"]').length > 0 )
		{
			if(filter === 'omraader')
			{
				dataholder.selectedAreaHolder = [];
				updateSelectedAreas([],true);
			}
			else if(filter === 'ankomst')
			{
				searchParameters.removeParameter('useSpecificArrival')
				searchParameters.removeParameter('specificAnkomst')
			}
			$('select.searchValue[name="'+filter+'"]').val('none').trigger('change');
		}
		else if( $('input.searchValue[name="'+filter+'"]').length > 0)
		{
			if(filter === 'textQuery')
			{
				$('input.searchValue[name="'+filter+'"]').val('').trigger('input');
			}
			else if(filter === 'dateRange')
			{
				if(dataholder.dateRangeDatePicker !== false)
					dataholder.dateRangeDatePicker.setValue('');
				$('input.searchValue[name="'+filter+'"]').val('');
				updateDateRangeValue();
			}
			else
			{
				$('input.searchValue[name="'+filter+'"]').trigger('click');
			}

		}
		else {
			searchParameters.removeParameter(filter)
			$('select.searchValue[name="ankomst"]').trigger('change');
		}
	});






	/***********************************************************************
		  .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-
		 / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \
		`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'
	                        MOBILE SHOW STATE

	************************************************************************/

	$(document).on("click", ".mobileSearchCloseEsmark", function(evt){
		evt.stopPropagation();
		evt.preventDefault();
		$('body').toggleClass("searchAreaShown");
		$(document).find("#searcharea").toggleClass("showit");
		$(document).find("#search-kat-number").toggleClass("showit");
		if( !$('body').hasClass('stickyNavBar') )
		{
			$('html,body').animate({
				scrollTop: ($(document).find(".search-wrap").offset().top) - 50
			}, 300);
		}
	});

	$(document).on("click", ".mobileSearchBtnEsmark", function(e){

		if( !$(e.currentTarget).hasClass('isLink') ) {
			e.stopPropagation();
			e.preventDefault();
			$("#freeSearchOutputWrapper").removeClass("active");
			$('body').toggleClass("searchAreaShown");
			$(document).find("#searcharea").toggleClass("showit");
			$(document).find("#search-kat-number").toggleClass("showit");

			if(window.location.href.indexOf(siteSearchPage) !== -1)
			{
				$('#r_arrow').click();
			}

			if (!$('body').hasClass('stickyNavBar')) {
				$('html,body').animate({
					scrollTop: ($("#searcharea").offset().top) - 50
				}, 300);
			}
		}
	});




	/***********************************************************************
		  .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-
		 / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \
		`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'
								RESETS

	************************************************************************/


	$(document).on('click', '#frontAdvancedResetBtn', function (e) {
		resetAllSearchParts();
	});
});


function generateOffDateArrivalOptions()
{
	const arrival = searchParameters.getParameter('specificAnkomst');
	$('#dateSelect option[data-fake=true]').remove();
	if(arrival !== undefined)
	{
		if($('#dateSelect option[value='+arrival+']').length === 0)
		{
			const dateNames = {
				1: ['Søndag','Mandag','Tirsdag','Onsdag','Torsdag','Fredag','Lørdag'],
				2: ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag']
			}
			const date = new Date(Date.parse(arrival));
			const weekday = date.getDay();
			const dateString =('0' + date.getDate()).slice(-2)+'-'+('0' + (date.getMonth()+1)).slice(-2)+'-'+(date.getFullYear()+'').slice(-2);
			$('#dateSelect').append('<option selected="selected" data-fake="true" value="'+arrival+'">.. '+dateNames[siteID][weekday]+', '+dateString+' ('+(Number(siteID) === 2 ?  'woche' : 'uge' )+' '+ getDateWeekNr(date)+')</option>');
		}
	}
}

